import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../../common/TableDefinitions';
import { MRDContactsTableColumns } from '../../containers/MRDContactsTableColumns';
import AddContactDialogColumns from '../../containers/AddContactDialogColumns';

export const getContactListByImpc = (state) => state.listing.MRD_CONTACTS_WIZARD.data;
export const getIsContactListByImpcLoading = (state) => state.listing.MRD_CONTACTS_WIZARD.isLoading;
export const getData = TableDefinitions.MRD_CONTACTS_WIZARD.getDataFunction();
export const getColumns = createSelector(getData, MRDContactsTableColumns);

export const getAllContacts = (state) => state.listing.ALL_CONTACTS.data;
export const getIsAllContactsLoading = (state) => state.listing.ALL_CONTACTS.isLoading;
export const getAllContactsColumns = createSelector(getAllContacts, AddContactDialogColumns);

export const getAssociateRequestStatus = (state) => state.contacts.associateContactRequestLoading;
export const getCreateRequestStatus = (state) => state.contacts.createContactRequestLoading;
